import React, { PropsWithChildren } from 'react';
import { MessageWrapper } from '../components/MessageWrapper/MessageWrapper';
import { SignUpContextProvider } from '../components/SignUp/provider/SignUpProvider';
import { UnsupportedBrowsersWrapper } from '../components/UnsupportedBrowsersWrapper/UnsupportedBrowsersWrapper';
import { AcquisitionContextProvider } from './AcquisitionProvider/AcquisitionProvider';
import { ApiTokenProvider } from './ApiTokenProvider/ApiTokenProvider';
import FeatureFlagProvider from './FeatureFlagProvider/FeatureFlagProvider';
import LoaderProvider from './Loader/LoaderProvider';
import { MitekContextProvider } from './MitekProvider/MitekProvider';
import { ModalProvider } from './Modal/Modal';
import PersonalizationCustomizationContextProvider from './PersonalizationCustomizationProvider/PersonalizationCustomizationProvider';
import { PushdownProvider } from './Pushdown/PushdownProvider';
import SessionStorageStatusProvider from './SessionStorageStatus/SessionStorageStatusProvider';
import { SideMenuProvider } from './SideMenuProvider/SideMenuProvider';
import { SpeedbumpProvider } from './Speedbump/Speedbump';
import TermRatesProvider from './TermRates/TermRates';
import WhitelistProvider from './WhitelistProvider/WhitelistProvider';
import { WidthContextProvider } from './Width';
import { ModernAcquisitionProvider } from './ModernAcquisitionProvider/ModernAcquisitionProvider';

const Core = ({ children }) => (
    <UnsupportedBrowsersWrapper>
        <FeatureFlagProvider>
            <ApiTokenProvider>
                <WidthContextProvider>
                    <ModalProvider>
                        <PushdownProvider>
                            <SpeedbumpProvider>
                                <SessionStorageStatusProvider>
                                    <SignUpContextProvider>
                                        <TermRatesProvider>
                                    {children}
                                        </TermRatesProvider>
                                    </SignUpContextProvider>
                                </SessionStorageStatusProvider>
                            </SpeedbumpProvider>
                        </PushdownProvider>
                    </ModalProvider>
                </WidthContextProvider>
            </ApiTokenProvider>
        </FeatureFlagProvider>
    </UnsupportedBrowsersWrapper>
);

const Acquisitions = ({ children, includeAcquisitionProvider }) =>
    includeAcquisitionProvider ? (
            <ModernAcquisitionProvider>
                <AcquisitionContextProvider>
                    <PersonalizationCustomizationContextProvider>
                        <WhitelistProvider>
                            <LoaderProvider>
                                    {children}
                            </LoaderProvider>
                        </WhitelistProvider>
                    </PersonalizationCustomizationContextProvider>
                </AcquisitionContextProvider>
            </ModernAcquisitionProvider>
    ) : (
        <>{children}</>
    );

const Mitek = ({ children }) =>
    window.location.pathname.includes('ID-verify') ? (
        <MitekContextProvider>{children}</MitekContextProvider>
    ) : (
        <>{children}</>
    );

const AllProvider = ({
    children,
    includeAcquisitionProvider,
}: PropsWithChildren<{ includeAcquisitionProvider?: boolean }>) => {
    return (
        <Core>
            <Mitek>
                <Acquisitions
                    includeAcquisitionProvider={includeAcquisitionProvider}
                >
                    <div className='aem-page-container'>
                        <SideMenuProvider>
                            <MessageWrapper>{children}</MessageWrapper>
                        </SideMenuProvider>
                    </div>
                </Acquisitions>
            </Mitek>
        </Core>
    );
};

export default AllProvider;
